{
    let mobileMenuItems = document.querySelectorAll(".js-menu-item");
    
    if(mobileMenuItems.length > 0) {
        mobileMenuItems.forEach((button) => {
            button.addEventListener("click",(e)=>{
                let buttonLink = e.target.href;
                let buttonText = e.target.textContent;
                let buttonPosition = e.target.dataset.itemPosition;
                let menuNameDiv = e.target.closest('collapsible-content');
                let menuName = menuNameDiv.dataset.itemName;
                let buttonLocation = menuNameDiv.dataset.location;

                tagular("ElementClicked", {
                    actionOutcome: "INTERNALLINK",
                    outboundUrl: `${buttonLink}`,
                    webElement: {
                        elementType: "Link",
                        htmlId: null,
                        location: buttonLocation,
                        name: menuName,
                        position: buttonPosition,
                        text: buttonText,
                        variant: null
                    }
                });
            })
        })
    }
}

{
    let mobileMenuProducts = document.querySelectorAll(".js-menu-product");

    if(mobileMenuProducts.length > 0) {
        mobileMenuProducts.forEach((button) => {
            button.addEventListener("click",(e)=>{
                let buttonLink = e.target.href;
                let buttonText = e.target.textContent;
                let buttonPosition = parseInt(e.target.dataset.itemPosition);
                let menuNameDiv = e.target.closest('collapsible-content');
                let menuName = menuNameDiv?.dataset.itemName;
                let buttonLocation = menuNameDiv?.dataset.location;
                let menuParent = menuNameDiv?.closest('#mobile-menu-1-1');
                let menuLocation = menuParent?.dataset.itemName;
                let productType = e.target.dataset.productType;
                let variantType = e.target.dataset.productVariant;
                let prodcutSku = e.target.dataset.productSku;
                let prodcutPrice = Number(e.target.dataset.productPrice.replace(/[^0-9.-]+/g, ""));

                tagular("ProductClicked", {
                    actionOutcome: "INTERNALLINK",
                    correlationId: null,
                    viewCorrelationId: null,
                    listId: null,
                    outboundUrl: `${buttonLink}`,

                    product: {
                        brand: "SHOP",
                        category: menuName,
                        coupon: null,
                        formatSubtype: null,
                        formatType: `${productType}`,
                        location: `${buttonLocation} - ${menuLocation}`,
                        name: buttonText,
                        pageId: null,
                        position: buttonPosition,
                        price: prodcutPrice,
                        productId: null,
                        quantity: 1,
                        sku: prodcutSku,
                        subscription: {
                            frequency: null
                        },
                        text: buttonText,
                        upc: null,
                        variant: variantType,
                        positionEngine: null
                    }
                });
            })
        })
    }
}

{
    let productCategories = document.querySelectorAll(".js-product-category");
    
    if(productCategories.length > 0) {
        productCategories.forEach((button) => {
            button.addEventListener("click",(e)=>{
                let buttonLink = e.target.href;
                let buttonText = e.target.textContent;
                let buttonPosition = e.target.dataset.itemPosition;
                let buttonName = e.target.dataset.itemName;

                tagular("ElementClicked", {
                    actionOutcome: "INTERNALLINK",
                    outboundUrl: buttonLink,
                    webElement: {
                        elementType: "Tile",
                        htmlId: null,
                        location: `Shop Sub Nav - Products - ${buttonText}`,
                        name: buttonText,
                        position: buttonPosition,
                        text: buttonText,
                        variant: null
                    }
                });
            })
        })
    }
}